module.exports = __webpack_public_path__ + "img/fds.2be2636d.png";